import React, { Component, PropTypes } from 'react';

export default class SubCategoryTestimonial extends Component {
  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.subcatId != this.props.subcatId) {
      this.fetch();
    }
  }

  fetch() {
    const { subcatId, fetchTestimonials } = this.props;
    if (subcatId) {
      fetchTestimonials(subcatId);
    }
  }

  render() {
    const { testimonial, subcatId } = this.props;

    if (!testimonial || !subcatId) {
      return null;
    }

    return (
      <div className="subcat-testimonial">
        <div className="body">{ testimonial.body }</div>
        <div className="author">-{ testimonial.author }</div>
      </div>
    );
  }
}

SubCategoryTestimonial.propTypes = {
  testimonial: PropTypes.object,
  subcatId: PropTypes.number,
  fetchTestimonials: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./marketing/components/sub_category_testimonial.jsx